export enum Eligibility{
    STUDENTDETAILSFILTER = 'Student Detail Filters',
}

export const StudentDetailsFilters = [
    { label: 'Campus', value: 'campus', isActive: true },
    { label: 'Department', value: 'department', isActive: false },
    { label: 'Degree & Specialization', value: 'degreeSpec', isActive: false },
    { label: 'Pass Out Year', value: 'passOutYear', isActive: false },
]

export const PreviewEligibilityKeys = {
    'campus': 'Campus',
    'degree_specialization': 'Degree & Specialization',
    'pass_out_year': 'Pass Out Year',
    'gender': 'Gender',
    'tenth_cgpa': '10th CGPA',
    'tenth_percentage': '10th Percentage',
    'twelfth_cgpa': '12th CGPA',
    'twelfth_percentage': '12th Percentage',
    'ug_cgpa':  'UG CGPA',
    'ug_percentage': 'UG Percentage',
    'group_cgpa': 'Group CGPA',
    'group_percentage': 'Group Percentage',
    'diploma_cgpa': 'Diploma CGPA',
    'diploma_percentage': 'Diploma Percentage',
    'pg_percentage': 'PG Percentage',
    'pg_cgpa': 'PG CGPA',
    'current_backlogs': 'Current Backlogs',
    'backlog_history': 'Backlog History',
    'placedCompany': 'Placed Company',
    'companyCategory': 'Company Category',
    'placedCount': 'Placed Count',
    'salary': 'Salary',
    'stipend': 'Stipend',
    'offerType': 'Offer Type',
    'studentType': 'Student Type',
    'placementCategory': 'Placement Category',
}